import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SgLabelTextSize } from '../sg-label/sg-label.component';

@Component({
  selector: 'sg-lending-rate-label',
  template: ` <sg-label
    class="value-label"
    [text]="lendingRateBps | sgRatePercent"
    variant="turquoise"
    inverted="true"
    [size]="size"></sg-label>`,
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LendingRateLabelComponent {
  @Input() lendingRateBps?: number;
  @Input() size: SgLabelTextSize = 'medium';
}
